<template>
    <div>
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="1041px"
            @close="setDialogClosed">
            <el-container direction="vertical">
                <el-row>
                    <el-button type="primary" style="float: right;" @click="importNewIntegratedSolution">导入一体化管理方案</el-button>
                </el-row>
                <el-row style="margin-top: 10px;">
                    <el-col :span="8">
                        <el-table size="small" ref="singleTable" :data="dataList1" height="400px" border fit highlight-current-row
                            style="width: 100%;" @current-change="handleCurrentChange">
                            <el-table-column label="一体化管理方案">
                                <el-table-column label="项目">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.item }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="频次">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.fre }}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                    </el-col>

                    <el-col :span="16">
                        <el-table size="small" :data="dataList2" height="400px" border fit style="width: 100%;"
                            :header-cell-style="{ backgroundColor: '#66b1ff', color: '#fff' }">
                            <el-table-column label="落实情况">
                                <el-table-column width="50px" label="次数">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.index }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="时间">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.time }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="项目">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.item }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="50px" label="结果">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.result }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="80px" label="是否达标">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.reachStandard }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="80px" label="是否逾期">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.expire }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="下次时间">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.nextTime }}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <patient-integration-produce v-if="patientIntegrationProduceVisible" ref="patientIntegrationProduceRef">
                </patient-integration-produce>
            </el-container>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment";
import patientIntegrationProduce from "./patientIntegrationProduce.vue";

export default {
    components: { patientIntegrationProduce },
    data() {
        return {
            showDialog: false,
            title: "一体化管理方案详情",
            dataContext: null,
            patientIntegrationProduceVisible: false,
            list: null,
            listLoading: false,
            currentRow: null,
            dataList1: [
                {
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                },
                {
                    item: "健康档案建立维护",
                    fre: "3个月1次"
                }
            ],
            dataList2: [
                {
                    index: '1',
                    time: '2025-01-25 08:23',
                    item: '空腹血糖',
                    result: '4.6',
                    reachStandard: '达标',
                    expire: '否',
                    nextTime: '2025-02-25 08:23'
                },
                {
                    index: '1',
                    time: '2025-01-25 08:23',
                    item: '空腹血糖',
                    result: '4.6',
                    reachStandard: '达标',
                    expire: '否',
                    nextTime: '2025-02-25 08:23'
                },
                {
                    index: '1',
                    time: '2025-01-25 08:23',
                    item: '空腹血糖',
                    result: '4.6',
                    reachStandard: '达标',
                    expire: '否',
                    nextTime: '2025-02-25 08:23'
                },
                {
                    index: '1',
                    time: '2025-01-25 08:23',
                    item: '空腹血糖',
                    result: '4.6',
                    reachStandard: '达标',
                    expire: '否',
                    nextTime: '2025-02-25 08:23'
                }
            ]
        };
    },
    methods: {
        // 编辑初始化页面内容
        async init(dataContext) {
            console.log("一体化详情界面：", dataContext);
            this.dataContext = dataContext;
            this.showDialog = true;
            this.$nextTick(() => {
                this.getDetail();
            });

            this.setCurrent(this.dataList1[0]);
        },
        // 关闭对话框触发
        setDialogClosed() {
            this.showDialog = false;
        },
        getParsedTime(time) {
            return moment(time).format("YYYY-MM-DD HH:mm");
        },
        getDetail() {

        },
        setCurrent(row) {
            this.$refs.singleTable.setCurrentRow(row);
        },
        handleCurrentChange(val) {
            this.currentRow = val;
        },
        //导入一体化方案
        importNewIntegratedSolution() {
            this.patientIntegrationProduceVisible = true;
            this.$nextTick(() => {
                this.$refs["patientIntegrationProduceRef"].init(this.dataContext)
            })
        }
    },
};
</script>

<style scoped>
.custom-class {
    color: white;
}

.cardColorBlue {
    background: linear-gradient(to right, #9fccfc, #618bff);
}

::v-deep .el-table__body tr.current-row>td {

    background: #66b1ff !important;

    color: #ffffff !important;

}
</style>